import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import "../css/Login.css";
import "../css/ForgotPassword.css";

export default function ForgotPassword() {
  const { forgotPassword, loading, error } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [localError, setLocalError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError("");

    if (!email.includes("@")) {
      setLocalError("Please enter a valid email address");
      return;
    }

    const data = await forgotPassword(email);
    if (data) {
      navigate("/reset-password", { state: { user_id: data.user_id, email } });
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-main">
        <div className="login-left">
          <h2>Reset Password</h2>
          <p className="login-aidora-text">
            Enter your email and we'll send you a reset OTP.
          </p>
        </div>

        <motion.div
          className="login-right"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div className="login-card">
            <h2>Forgot Password</h2>

            <form onSubmit={handleSubmit}>
              {(error || localError) && (
                <div className="login-error">{error || localError}</div>
              )}

              <div className="login-floating-field">
                <input
                  type="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label>Email Address</label>
              </div>

              <button className="login-button" disabled={loading}>
                {loading ? "Sending..." : "Send OTP"}
              </button>

              <button
                type="button"
                className="login-signup-button"
                onClick={() => navigate("/")}
              >
                Back to Login
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
